import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    html {
        box-sizing: border-box;
        scroll-behavior: smooth;
    }

    *, ::after, ::before {
        box-sizing: inherit;
    }

    body {
        background: ${({ theme }) => theme.color.light};
        color: ${({ theme }) => theme.color.black};
        word-break: break-word;
        font-family: "Roboto", sans-serif;
        margin: 0;
        -webkit-font-smoothing: antialiased;
    }

    button, input, select, textarea { font: inherit; }
    @media (max-width: 767px) {
        body { padding-bottom: calc(76px + env(safe-area-inset-bottom, 0px)); }
    }
    #jak-pomagamy { scroll-margin-top: 110px; }

    :focus-visible {
        outline: 3px solid rgba(255, 169, 0, 0.55);
        outline-offset: 3px;
    }

    #dlaczego-my, #kredyty, #kontakt, #formularz, #dla-firmy, #faq, #opinie, #wyniki-kalkulatora, #wynik-raty {
        scroll-margin-top: 110px;
    }

    @media (prefers-reduced-motion: reduce) {
        html { scroll-behavior: auto; }
        *, *::before, *::after { animation: none !important; transition: none !important; }
    }

    @media print {
        #root > nav,
        #root > footer,
        aside[aria-label="Szybki kontakt"] {
            display: none !important;
        }

        body { background: #fff; padding-bottom: 0; }
    }

    h1 {
        font-size: clamp(36px, 5vw, 56px);
        font-weight: 900;
        letter-spacing: -0.04em;

        @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
            font-size: 27px;
        }
    }

    h2 {
        font-size: clamp(34px, 5vw, 52px);
        font-weight: 900;
        letter-spacing: -0.035em;

        @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
            font-size: 27px;
        }
    }

    h3 {
        font-size: 36px;
        font-weight: 900;

        @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
            font-size: 27px;
        }
    }

    h4 {
        font-size: 26px;
        line-height: 52px;
        font-weight: 700;
    }

    section {
        padding: 64px clamp(16px, 5vw, 72px);

        @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
            padding: 48px 16px;
        }
    }

    p {
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;

        @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 8px;
            margin-top: 8px;
        }
    }

`;

